/**
 * Central environment configuration.
 *
 * API_MODE is read from REACT_APP_API_MODE:
 *   mock  — in-memory mock data, no backend required (safe default)
 *   local — local Spring Boot at localhost:8080
 *   prod  — production backend
 *
 * To switch modes without rebuilding:
 *   • Create/edit .env.local and set REACT_APP_API_MODE=local (or prod)
 *   • .env.local is gitignored and overrides .env on npm start
 */

const MODE = process.env.REACT_APP_API_MODE || 'mock';

const BASE_URLS = {
  mock: null,
  local: process.env.REACT_APP_API_BASE_URL_LOCAL || 'http://localhost:8080/api/v1',
  prod: process.env.REACT_APP_API_BASE_URL_PROD || 'https://api.skinnthrive.com/api/v1',
};

const env = {
  mode: MODE,
  isMock: MODE === 'mock',
  isLocal: MODE === 'local',
  isProd: MODE === 'prod',
  apiBaseUrl: BASE_URLS[MODE] || BASE_URLS.local,
};

// Log active mode in development so it's always visible in console
if (process.env.NODE_ENV === 'development') {
  console.info(
    `%c[API] mode=${env.mode}  baseUrl=${env.apiBaseUrl ?? '(none — using mock data)'}`,
    'color:#7C3AED;font-weight:bold'
  );
}

export default env;
